/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.food-services.menu-items'},
});

const MenuItemsItem = () => (
  <RouteLinkItem
    route="midas/settings/food-services/menu-items"
    title={messages.title}
  />
);

export default MenuItemsItem;
